/* eslint-disable @typescript-eslint/no-explicit-any */

import chalk from 'chalk'
import { env } from '../env'
import { Logger } from './logging'
export class CLIColorLogger implements Logger {
	log(message: string, rest?: any): void {
		console.log(chalk.blue(message), rest ?? '')
	}

	info(message: string, rest?: any): void {
		console.log(chalk.blue(message), rest ?? '')
	}

	warn(message: string, rest?: any): void {
		console.log(chalk.yellow(message), rest ?? '')
	}

	error(message: string, rest?: any): void {
		console.log(chalk.red('✖'), message, rest ?? '')
	}
	time(label?: string): void {
		console.time(label)
	}

	timeEnd(label?: string): void {
		console.timeEnd(label)
	}

	debug(message: string, rest?: any): void {
		if (env.HASHNODE_DEBUG) console.debug(message, rest ?? '')
	}

	clear(): void {
		console.clear()
	}

	success(message: string, rest?: any): void {
		console.log(`${chalk.green('✔️')} `, message, rest ?? '')
	}
	exception(e: Error, rest?: any): void {
		this.error(
			chalk.red(e.toString()) + (env.HASHNODE_DEBUG ? '\n' + chalk.gray(e.stack) : ''),
			rest,
		)
	}

	exit(message: string | Error, code: number = 1, rest?: any): never {
		if (message instanceof Error) {
			this.exception(message, rest ?? '')
			process.exit(code)
		}

		if (message) {
			if (code === 0) {
				this.log(message)
			} else {
				this.error(message, rest ?? '')
			}
		}

		process.exit(code)
	}
}
